
import React, { useState } from "react";
import {
  useNavigate,
  useParams,
  useLocation,
} from "react-router-dom";

import AppHeader from "../components/AppHeader";
import NotationExcelSheet from "../components/NotationExcelSheet";
import NotationDetailsPanel from "../components/NotationDetailsPanel";
import FifthTree from "../components/FifthTree";

import {
  Panel,
  PanelGroup,
  PanelResizeHandle,
} from "react-resizable-panels";

interface TreeNode {
  text: string;
  tag: number;
  color?: string;
  children: TreeNode[];

  wbsNo?: number;
  notationNo?: number;
  notationHead?: number;
  sequence?: number;
  front?: number;
}

const FifthPanel = () => {
  const navigate = useNavigate();
  const { id } = useParams<{ id: string }>();
  const location = useLocation();

  const [projectName, setProjectName] = useState(
    location.state?.projectName ||
      localStorage.getItem("projectName") ||
      ""
  );

  const userName = localStorage.getItem("userName");

  const projectId = Number(id);
  const refresh = 0;

  const [selectedNode, setSelectedNode] =
    useState<TreeNode | null>(null);

  const [selectedNotation, setSelectedNotation] =
    useState<any>(null);

  const [showNotationPopup, setShowNotationPopup] =
    useState(false);

  const handleTreeSelect = (node: TreeNode) => {
    console.log("Fifth Panel Selected:", node);
    setSelectedNode(node);
  };

  return (
    <div
      className="h-screen flex flex-col overflow-hidden bg-gray-100"
      style={{
        fontFamily: "'Segoe UI', sans-serif",
        fontSize: "13px",
        fontWeight: 400,
      }}
    >
      {/* =====================================================
          APP HEADER
      ===================================================== */}

      <AppHeader
        title={projectName || id || "Marks Table"}
        userName={userName}
        activeTab="fifth"

        onBack={() => navigate(-1)}

        onHome={() => navigate("/projects")}

        onDashboard={() =>
          navigate(`/project/${id}`, {
            state: { projectName },
          })
        }

        onSecond={() =>
          navigate(`/project/${id}/second`, {
            state: { projectName },
          })
        }

        onThird={() =>
          navigate(`/project/${id}/third`, {
            state: { projectName },
          })
        }

        onFourth={() =>
          navigate(`/project/${id}/fourth`, {
            state: { projectName },
          })
        }

        onFifth={() =>
          navigate(`/project/${id}/fifth`, {
            state: { projectName },
          })
        }

        onLogout={() => {
          sessionStorage.clear();
          localStorage.removeItem("token");
          navigate("/login");
        }}

        projectId={projectId}

        onProjectUpdated={(updatedName) => {
          setProjectName(updatedName);
        }}
      />

      {/* =====================================================
          MAIN CONTENT
      ===================================================== */}

      <div className="flex-1 min-h-0 overflow-hidden">

        <PanelGroup
          direction="horizontal"
          autoSaveId="fifth-tab-layout"
          className="flex h-full min-h-0 overflow-hidden bg-white"
        >

          {/* =================================================
              LEFT PANEL - WBS TREE (25%)
          ================================================= */}

          <Panel defaultSize={25} minSize={15}>
            <div className="flex h-full min-h-0 flex-col overflow-hidden bg-white">

              {/* PANEL HEADER */}
              <div className="shrink-0 px-4 pt-4 pb-2">
                <h2>Work Breakdown Structure</h2>
              </div>

              {/* WBS TREE */}
              <div className="flex-1 min-h-0 overflow-auto">
                <FifthTree
                  projectId={projectId}
                  refresh={refresh}
                  onSelect={handleTreeSelect}
                />
              </div>

            </div>
          </Panel>

          {/* =================================================
              RESIZE HANDLE
          ================================================= */}

          <PanelResizeHandle className="w-px shrink-0 bg-white border-0 cursor-col-resize" />

          {/* =================================================
              RIGHT PANEL - NOTATION (75%)
          ================================================= */}

          <Panel defaultSize={75} minSize={25}>
            <div className="h-full min-h-0 overflow-auto bg-white p-3">

              {selectedNode ? (
                <NotationExcelSheet
                  selectedWorkTreeNode={selectedNode.wbsNo ?? null}
                  onNotationSelect={(notation) => {
                    setSelectedNotation(notation);
                    setShowNotationPopup(true);
                  }}
                />
              ) : (
                <div className="flex h-full items-center justify-center text-gray-500">
                  Select a WBS from the tree.
                </div>
              )}

            </div>
          </Panel>

        </PanelGroup>

      </div>

      {/* =====================================================
          NOTATION DETAILS POPUP
      ===================================================== */}

      {showNotationPopup && selectedNotation && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40">

          <div
            className="relative rounded-lg bg-white shadow-2xl"
            style={{
              width: "75vw",
              height: "80vh",
            }}
          >

            {/* CLOSE BUTTON */}
            <button
              onClick={() => {
                setShowNotationPopup(false);
                setSelectedNotation(null);
              }}
              style={{
                position: "absolute",
                top: 10,
                right: 10,
                zIndex: 1000,
                width: 34,
                height: 34,
                borderRadius: "50%",
                border: "none",
                background: "#ef4444",
                color: "#fff",
                cursor: "pointer",
                fontSize: "18px",
                fontWeight: "bold",
              }}
            >
              ✕
            </button>

            {/* NOTATION DETAILS */}
            <NotationDetailsPanel
              projectId={projectId}
              selectedNode={selectedNotation}
            />

          </div>

        </div>
      )}

    </div>
  );
};

export default FifthPanel;
